module.exports = __webpack_public_path__ + "static/media/info.ee93fb45.png";